
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDelegatiDialog extends Serenity.EntityDialog<UtentiDelegatiRow, any> {
        protected getFormKey() { return UtentiDelegatiForm.formKey; }
        protected getIdProperty() { return UtentiDelegatiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiDelegatiRow.localTextPrefix; }
        protected getService() { return UtentiDelegatiService.baseUrl; }
        protected getDeletePermission() { return UtentiDelegatiRow.deletePermission; }
        protected getInsertPermission() { return UtentiDelegatiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiDelegatiRow.updatePermission; }

        protected form = new UtentiDelegatiForm(this.idPrefix);

    }
}